module.exports = __webpack_public_path__ + "img/single-quote.fe03be3a.svg";